import { render } from "./ChannelProducts.vue?vue&type=template&id=58838ceb"
import script from "./ChannelProducts.vue?vue&type=script&lang=js"
export * from "./ChannelProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__